/** Store settings pages, the theme customiser shell, domains and email. Conventions: see `common.ts`. */
const store: Record<string, string> = {
  // >>> customizer
  'customizer.devices.desktop': 'Desktop preview',
  'customizer.devices.tablet': 'Tablet preview',
  'customizer.devices.mobile': 'Mobile preview',
  'customizer.color_mode.preview_dark': 'Preview in dark mode',
  'customizer.color_mode.preview_light': 'Preview in light mode',
  'customizer.color_mode.hint': 'See how your shop looks in its other mode. Only the preview changes.',
  'customizer.status.unsaved': 'Unsaved changes',
  'customizer.status.saved_just_now': 'Saved just now',
  'customizer.status.saved_seconds_ago': 'Saved {seconds} seconds ago',
  'customizer.status.saved_a_minute_ago': 'Saved a minute ago',
  'customizer.status.saved_minutes_ago': 'Saved {minutes} minutes ago',
  'customizer.status.last_saved': 'Last saved {date}',
  'customizer.notices.saved_live': 'Published - your shop is updated.',
  'customizer.notices.published': 'This theme is now live.',
  'customizer.errors.image_save_failed_reason': 'Could not save that image: {message}',
  'customizer.errors.image_save_failed': 'Could not save that image. Please try again.',
  'customizer.errors.save_failed': 'Could not save the theme.',
  'customizer.errors.publish_failed': 'Could not publish the theme.',
  'customizer.errors.logo_save_failed': 'Could not save your logo.',
  'customizer.loading': 'Loading the customiser…',
  'customizer.not_found.title': 'Theme not found',
  'customizer.not_found.description': 'It may have been deleted, or it belongs to another store.',
  'customizer.back_to_store': 'Back to your store',
  'customizer.reset_page_confirm': 'Reset the {page} to how this theme ships it?',
  'customizer.reset_all_confirm': 'Throw away every change since the last save?',
  'customizer.theme_sections': '{theme} sections',
  'customizer.reset_page': 'Reset this page',
  'customizer.reset_all': 'Reset all changes',
  'customizer.theme_name': 'Theme name',
  'customizer.settings_empty':
    'Pick any part of the page - a banner, a product grid, a review - and its settings open here.',
  'customizer.preview_empty': 'Add a section and it will appear here.',
  'customizer.footer': 'Footer',
  'customizer.block': 'Block',
  'customizer.edit_item': 'Edit {name}',
  'customizer.undo': 'Undo',
  'customizer.undo_shortcut': 'Undo (Ctrl+Z)',
  'customizer.redo': 'Redo',
  'customizer.redo_shortcut': 'Redo (Ctrl+Shift+Z)',
  'customizer.ask.open': 'Ask AI',
  'customizer.ask.hint': 'Describe a change in your own words, and AI makes it in your draft.',
  'customizer.ask.close': 'Close Ask AI',
  'customizer.more_tools': 'More tools',
  'customizer.mode': 'How many settings to show',
  'customizer.mode.simple': 'Simple',
  'customizer.mode.advanced': 'All settings',
  'customizer.view_store': 'View store',
  'customizer.view_page_on_store': 'View the {page} on your store',
  'customizer.publish': 'Publish',
  'customizer.publish_hint': 'Publish - make this the theme your shoppers see',
  'customizer.editing_live':
    'You are editing your live theme. Shoppers see nothing new until you press Publish.',
  'customizer.recovery.message': 'You left changes to this theme unsaved on this computer.',
  'customizer.recovery.restore': 'Restore them',
  'customizer.recovery.discard': 'Discard',
  'customizer.read_only': 'You have read-only access to store settings, so this is a preview only.',
  'customizer.status.live_pending': 'Changes not live yet',
  'customizer.status.draft_saved': 'Saved as draft · not live yet',
  'customizer.status.live_pill': 'Live',
  'customizer.publish_live_hint': 'Put your changes on your live shop',
  'customizer.publish_nothing': 'Nothing new to publish',
  'customizer.publishing': 'Publishing…',
  'customizer.outline': 'Page outline',
  'customizer.outline_hint': 'See this page as a list you can drag to rearrange',
  'customizer.close_panel': 'Close',
  'customizer.breadcrumb': 'You are editing',
  'customizer.empty.title': 'Click any part of your shop to change it',
  'customizer.empty.add': 'Add a section',
  'customizer.empty.style': 'Change logo, colours and fonts',
  'customizer.add.here': 'Add section here',
  'customizer.add.title': 'Add a section',
  'customizer.add.purpose.products': 'Show products',
  'customizer.add.purpose.story': 'Tell your story',
  'customizer.add.purpose.trust': 'Build trust',
  'customizer.add.purpose.contact': 'Get in touch',
  'customizer.add.purpose.other': 'More sections',
  'customizer.page_switcher': 'Page: {page}. Change page',
  'customizer.page_search': 'Find a page',
  'customizer.page_search_placeholder': 'Search pages…',
  'customizer.pages': 'Pages',
  'customizer.page_search_empty': 'No page matches “{query}”.',
  'customizer.page_group.home': 'Home',
  'customizer.page_group.shop': 'Shop',
  'customizer.page_group.buying': 'Buying',
  'customizer.page_group.content': 'Content',
  'customizer.page_group.more': 'More pages',
  'customizer.page_note.off': 'off',
  'customizer.page_note.customised': 'customised',
  'customizer.page_note.draft': 'draft',
  'customizer.page_group.custom': 'Your pages',
  'customizer.page_new': 'New page',
  'customizer.tools.open': 'Search tools',
  'customizer.tools.open_hint': 'Find any tool or setting in the editor (Ctrl+K)',
  'customizer.tools.search': 'Search tools and settings',
  'customizer.tools.placeholder': 'Try “footer”, “colours” or “banner”…',
  'customizer.tools.empty': 'Nothing matches “{query}”.',
  'customizer.tools.results': 'Tools and settings',
  'customizer.tools.search_for': 'Search all tools for “{query}”',
  'customizer.tools.group.recent': 'Recently used',
  'customizer.tools.group.tools': 'Tools',
  'customizer.tools.group.settings': 'Theme settings',
  'customizer.tools.group.sections': 'Sections on this page',
  'customizer.tools.group.fields': 'Section settings',
  'customizer.tools.group.pages': 'Pages',
  'customizer.tools.terms.logo': 'logo favicon brand icon image upload',
  'customizer.tools.terms.colours': 'colours colors palette theme colour primary background text',
  'customizer.tools.terms.fonts': 'fonts typography typeface text style',
  'customizer.tools.terms.button_shape': 'buttons shape rounded corners pill square solid outline',
  'customizer.tools.terms.add_section': 'add new section block banner insert',
  'customizer.tools.terms.outline': 'outline layers tree list reorder rearrange drag move sections',
  'customizer.tools.terms.wording': 'wording text words labels messages translate copy rename',
  'customizer.tools.terms.plugins': 'plugins add-ons apps whatsapp popup chat widgets',
  'customizer.tools.terms.kits': 'festival kits diwali holi eid rakhi wedding sale seasonal',
  'customizer.tools.terms.ask': 'ask ai assistant help change automatically',
  'customizer.tools.terms.history': 'history versions undo restore earlier revert backup',
  'customizer.tools.terms.share': 'share preview link draft send review',
  'customizer.tools.terms.schedule': 'schedule date later timer go live automatically',
  'customizer.tools.terms.shopper_view': 'shopper view customer preview real store live look',
  'customizer.tools.terms.layout': 'layout theme family design style switch template header footer product listing',
  'customizer.tools.terms.logo_size': 'logo size width sticky header store name',
  'customizer.tools.terms.header_look': 'header look masthead top bar colour background button book appointment cta',
  'customizer.tools.terms.announcement': 'announcement bar banner rail offer message top strip',
  'customizer.tools.terms.footer': 'footer bottom colour style links',
  'customizer.tools.terms.header_menu': 'menu navigation mega menu categories departments nav',
  'customizer.tools.terms.language': 'language switcher translate hindi english flags',
  'customizer.tools.terms.type': 'font size typography heading body text scale',
  'customizer.tools.terms.buttons': 'buttons style radius corners solid outline',
  'customizer.tools.terms.cards': 'product cards badges sale new bestseller sold out quick add hover swatches',
  'customizer.custom_page.editing': 'You are designing your page “{title}”. Its sections save with Save page, separately from the theme; the header, footer and style come from this theme.',
  'customizer.custom_page.live_note': 'This page is published, so Save page updates it for shoppers straight away.',
  'customizer.custom_page.draft_note': 'This page is a draft: shoppers will not see it until you publish it in its settings.',
  'customizer.custom_page.settings': 'Page settings',
  'customizer.custom_page.save': 'Save page',
  'customizer.custom_page.save_hint': 'Save this page’s sections. The theme is saved and published separately.',
  'customizer.custom_page.saving': 'Saving page…',
  'customizer.custom_page.saved': 'Page saved.',
  'customizer.custom_page.save_failed': 'The page could not be saved.',
  'customizer.custom_page.load_failed': 'This page could not be loaded. It may have been deleted.',
  'customizer.custom_page.loading': 'Loading page…',
  'customizer.custom_page.unsaved': 'Unsaved page changes',
  'customizer.custom_page.discard_confirm': 'This page has unsaved changes. Leave it without saving them?',
  'customizer.actions.menu': 'Actions for {name}',
  'customizer.actions.duplicate': 'Duplicate',
  'customizer.actions.move_up': 'Move up',
  'customizer.actions.move_down': 'Move down',
  'customizer.actions.hide': 'Hide',
  'customizer.actions.show': 'Show',
  'customizer.actions.add_above': 'Add section above',
  'customizer.actions.add_below': 'Add section below',
  'customizer.actions.save_reusable': 'Save as reusable',
  'customizer.actions.delete': 'Delete',
  'customizer.actions.deleted': '{name} deleted',
  'customizer.actions.saved_reusable': 'Saved “{name}”. Find it under Add section on any page.',
  'customizer.first_run.title': 'Make this shop yours',
  'customizer.first_run.progress': '{done} of {total} done',
  'customizer.first_run.dismiss': 'Hide these tips',
  'customizer.first_run.step': '{number}. {step}',
  'customizer.first_run.logo': 'Add your logo',
  'customizer.first_run.colours': 'Pick your colours',
  'customizer.first_run.banner': 'Edit your home banner',
  'customizer.style.open': 'Style',
  'customizer.style.open_hint': 'Logo, colours, fonts and buttons for your whole shop',
  'customizer.style.logo_title': 'Logo & favicon',
  'customizer.style.colours_title': 'Colours',
  'customizer.style.palettes': 'Colour sets',
  'customizer.style.palette.original': 'Original',
  'customizer.style.palette.fresh': 'Fresh green',
  'customizer.style.palette.ocean': 'Ocean',
  'customizer.style.palette.saffron': 'Saffron',
  'customizer.style.palette.rose': 'Rose',
  'customizer.style.palette.royal': 'Royal',
  'customizer.style.palette.earth': 'Earth',
  'customizer.style.palette.mono': 'Black & white',
  'customizer.style.palette.night': 'Night',
  'customizer.style.palette.custom': 'Custom',
  'customizer.style.fonts_title': 'Fonts',
  'customizer.style.font.clean': 'Clean',
  'customizer.style.font.elegant': 'Elegant',
  'customizer.style.font.friendly': 'Friendly',
  'customizer.style.font.modern': 'Modern',
  'customizer.style.font.bold': 'Bold',
  'customizer.style.font.classic': 'Classic',
  'customizer.style.font.sturdy': 'Sturdy',
  'customizer.style.font_sample': 'Made with care, delivered to your door',
  'customizer.style.buttons_title': 'Buttons',
  'customizer.style.button_shape': 'Button shape',
  'customizer.style.shape.rounded': 'Rounded',
  'customizer.style.shape.soft': 'Soft',
  'customizer.style.shape.square': 'Square',
  'customizer.style.button_fill': 'Button fill',
  'customizer.style.fill.solid': 'Filled',
  'customizer.style.fill.outline': 'Outline',
  'customizer.style.wording': 'All store wording',
  'customizer.style.wording_hint': 'Every word on your shop’s buttons, menus and messages',
  'customizer.style.more': 'More style options',
  // >>> customizer round 3: history, shopper view, share, schedule, kits
  'customizer.history.open': 'History',
  'customizer.history.open_hint': 'Earlier versions of this theme - look at one or put it back',
  'customizer.history.title': 'Version history',
  'customizer.history.intro': 'Your theme is kept every time you publish, restore or let AI change it, and every few minutes while you edit. Newest first.',
  'customizer.history.loading': 'Loading earlier versions…',
  'customizer.history.load_failed': 'Could not load earlier versions. Please try again.',
  'customizer.history.empty': 'No earlier versions yet. They appear here as you save and publish.',
  'customizer.history.today': 'Today, {time}',
  'customizer.history.yesterday': 'Yesterday, {time}',
  'customizer.history.on_date': '{date}, {time}',
  'customizer.history.why_who': '{why} · {who}',
  'customizer.history.reason.autosave': 'Saved automatically',
  'customizer.history.reason.publish': 'Published',
  'customizer.history.reason.restore': 'Restored',
  'customizer.history.reason.scheduled': 'Festival switch',
  'customizer.history.reason.ai_assist': 'Changed by AI',
  'customizer.history.reason.other': 'Saved',
  'customizer.history.preview': 'Preview',
  'customizer.history.preview_named': 'Preview the version from {when}',
  'customizer.history.restore': 'Restore',
  'customizer.history.restore_named': 'Restore the version from {when}',
  'customizer.history.previewing': 'Previewing {when} - nothing has changed yet',
  'customizer.history.restore_this': 'Restore this',
  'customizer.history.back_to_edits': 'Back to my edits',
  'customizer.history.preview_failed': 'Could not open that version. Please try again.',
  'customizer.history.restore_live_confirm': 'This theme is live. Restoring the version from {when} changes your shop for customers right away. Continue?',
  'customizer.history.restored': 'Restored the version from {when}.',
  'customizer.history.restore_failed': 'Could not restore that version. Please try again.',
  'customizer.shopper_view.toggle': 'See it as shoppers do',
  'customizer.shopper_view.off': 'Back to the editable preview',
  'customizer.shopper_view.hint': 'See it as shoppers do: your real shop at a real phone, tablet or laptop width. Clicking inside it does not pick sections - turn it off to edit by clicking.',
  'customizer.shopper_view.devices': 'Device width',
  'customizer.shopper_view.device.mobile': 'Phone',
  'customizer.shopper_view.device.tablet': 'Tablet',
  'customizer.shopper_view.device.desktop': 'Laptop',
  'customizer.shopper_view.device_label': '{device} · {width} px wide, as shoppers see it',
  'customizer.shopper_view.frame_title': 'Your shop, as shoppers see it',
  'customizer.share.open': 'Share preview',
  'customizer.share.open_hint': 'Send a link to this draft to anyone - they can look, not change',
  'customizer.share.title': 'Share a preview',
  'customizer.share.intro': 'Anyone with this link can see this draft on your real shop, before it is live. They cannot change anything.',
  'customizer.share.making': 'Making your link…',
  'customizer.share.link_label': 'Preview link',
  'customizer.share.expiry': 'Works for 7 days, until {date}.',
  'customizer.share.copy': 'Copy link',
  'customizer.share.copied': 'Copied',
  'customizer.share.whatsapp': 'Send on WhatsApp',
  'customizer.share.whatsapp_message': 'Here is a sneak peek of the new look for {shop} - tell me what you think:',
  'customizer.share.stop': 'Stop sharing',
  'customizer.share.stopping': 'Stopping…',
  'customizer.share.retry': 'Try again',
  'customizer.share.failed': 'Could not make a preview link. Please try again.',
  'customizer.share.save_failed': 'Your latest changes could not be saved, so the link was not made. Check the message above and try again.',
  'customizer.share.live_unsaved': 'This theme is live, so your unpublished changes are not in the link - it shows the shop as published.',
  'customizer.share.draft_bar': 'This is a draft preview - not live yet. Shoppers still see the current shop.',
  'customizer.share.expired_bar': 'This preview link has expired. You are seeing the shop as it is today.',
  'customizer.share.exit': 'Exit preview',
  'customizer.share.see_live': 'Close',
  'customizer.schedule.open': 'Schedule',
  'customizer.schedule.open_hint': 'Make this look live on a date you choose, and put your current look back afterwards',
  'customizer.schedule.title': 'Schedule this look',
  'customizer.schedule.intro': 'Choose when this theme goes live. You do not need to be online - it switches by itself.',
  'customizer.schedule.start_date': 'Goes live on',
  'customizer.schedule.start_time': 'At',
  'customizer.schedule.with_end': 'Bring my current look back later',
  'customizer.schedule.end_date': 'Current look back on',
  'customizer.schedule.end_time': 'At',
  'customizer.schedule.ist_note': 'All times are India time (IST).',
  'customizer.schedule.summary': '{theme} goes live on {start} and stays until you change it.',
  'customizer.schedule.summary_with_end': '{theme} goes live on {start} and your current look comes back on {end}.',
  'customizer.schedule.create': 'Schedule',
  'customizer.schedule.creating': 'Scheduling…',
  'customizer.schedule.created': 'Scheduled. Your shop will switch by itself at the time you chose.',
  'customizer.schedule.live_note': 'This theme is already live. To plan a festival look, make a festival copy or open a draft theme and schedule that.',
  'customizer.schedule.existing': 'Already scheduled for this theme',
  'customizer.schedule.row': 'Goes live {start}',
  'customizer.schedule.row_with_end': 'Goes live {start}, back on {end}',
  'customizer.schedule.active': 'live now',
  'customizer.schedule.cancel': 'Cancel',
  'customizer.schedule.cancelled_by_publish': 'Your scheduled switch-back was cancelled because you published by hand.',
  'customizer.schedule.errors.start_missing': 'Choose the date and time this look goes live.',
  'customizer.schedule.errors.start_past': 'That time has already passed. Choose a time in the future.',
  'customizer.schedule.errors.end_missing': 'Choose when your current look comes back, or turn that off.',
  'customizer.schedule.errors.end_before': 'Your current look has to come back after this one goes live.',
  'customizer.schedule.errors.overlap': 'Another look is already scheduled for part of this time. Cancel it or choose different dates.',
  'customizer.schedule.errors.invalid': 'Those dates did not work. Check them and try again.',
  'customizer.schedule.errors.generic': 'Could not schedule this look. Please try again.',
  'customizer.kits.open': 'Festival looks',
  'customizer.kits.open_hint': 'Diwali, Holi, Eid, Rakhi, weddings and sales - colours, banner and offer in one click',
  'customizer.kits.title': 'Festival looks',
  'customizer.kits.intro': 'Each look changes your colours, adds a message to the announcement bar, rewrites your home page banner and adds an offer strip. Everything stays editable.',
  'customizer.kits.apply': 'Apply to this draft',
  'customizer.kits.apply_hint': 'Changes the theme open now. One Undo takes it off again.',
  'customizer.kits.make_copy': 'Make a festival copy',
  'customizer.kits.copy_hint': 'Copies your live theme, puts this look on the copy and opens it - your everyday look stays as it is.',
  'customizer.kits.with_products': 'Add a row of products',
  'customizer.kits.category': 'Show products from',
  'customizer.kits.all_products': 'All products',
  'customizer.kits.copy_in_english': 'The words are added in English, your shop’s language. Change them any time.',
  'customizer.kits.copy_in_hindi': 'The words are added in Hindi, your shop’s language. Change them any time.',
  'customizer.kits.applied': '{name} look applied.',
  'customizer.kits.copy_name': '{name} look',
  'customizer.kits.copy_made': 'Made “{name}”. Schedule it to go live on the day.',
  'customizer.kits.copy_failed': 'Could not make the festival copy. Please try again.',
  'customizer.kits.diwali.name': 'Diwali',
  'customizer.kits.diwali.description': 'Deep red and gold, lamps on the banner, and a gifts row.',
  'customizer.kits.holi.name': 'Holi',
  'customizer.kits.holi.description': 'Bright pink and playful colour, for the festival of colours.',
  'customizer.kits.eid.name': 'Eid',
  'customizer.kits.eid.description': 'Emerald green and gold, with an Eid Mubarak banner.',
  'customizer.kits.rakhi.name': 'Raksha Bandhan',
  'customizer.kits.rakhi.description': 'Warm saffron tones, with a reminder to order early.',
  'customizer.kits.wedding.name': 'Wedding season',
  'customizer.kits.wedding.description': 'Rich maroon and marigold, for the shaadi season.',
  'customizer.kits.sale.name': 'Big Sale',
  'customizer.kits.sale.description': 'Bold red for a sale, with space to say what is off.',
  // <<< customizer
  // >>> customizer: the platform's catalog theme customiser
  'customizer.platform.back': 'Back to themes',
  'customizer.platform.customize': 'Customize',
  'customizer.platform.customize_named': 'Customize {name}',
  'customizer.platform.banner.title': 'You are editing the catalog theme “{name}”',
  'customizer.platform.banner.body':
    'Your changes are saved to the theme itself. They only reach shops that apply it after you save - shops already wearing it keep their own copy.',
  'customizer.platform.banner.claims':
    'Feature strips, testimonials, booking calendars, product reviews and timelines are hidden for merchants when they apply the theme, until they switch them on for their own shop.',
  'customizer.platform.banner.visible':
    'This theme is visible to merchants, so nothing is saved until you press Save.',
  'customizer.platform.banner.hidden': 'This theme is hidden from merchants, so your changes save themselves as you go.',
  'customizer.platform.banner.short': 'Catalog theme “{name}”',
  'customizer.platform.banner.short_visible': 'Saved only when you press Save',
  'customizer.platform.banner.short_hidden': 'Changes save as you go',
  'customizer.platform.banner.details': 'Details',
  'customizer.platform.banner.hide': 'Hide this note',
  'customizer.platform.conflict.title': 'Somebody else saved this theme since you opened it.',
  'customizer.platform.conflict.body': 'Reload it to see their changes before you save again.',
  'customizer.platform.conflict.reload': 'Reload theme',
  'customizer.platform.conflict.reloading': 'Reloading…',
  'customizer.platform.errors.layout_changed':
    'A catalog theme keeps its layout. Switch the theme style back to {layout} to save.',
  'customizer.platform.errors.load_failed': 'Could not load this theme.',
  'customizer.platform.errors.try_again': 'Try again',
  'customizer.platform.hand_edited_confirm':
    'This replaces your hand edits to this theme, made in the customiser. A copy of them is kept in the theme’s version history. Carry on?',
  // <<< customizer: the platform's catalog theme customiser
  // >>> storefront-pages
  'storefront.schedule_pill': 'Goes live {start}',
  'storefront.schedule_pill_with_end': 'Goes live {start} · back to {theme} on {end}',
  'storefront.schedule_pill_active': 'Live now · back to {theme} on {end}',
  'storefront.schedule_pill_everyday': 'your current look',
  'storefront.all_industries': 'All industries',
  'storefront.title': 'Online store',
  'storefront.loading': 'Loading your storefront…',
  'storefront.empty.title': 'No storefront yet',
  'storefront.empty.description': 'Create your store to choose a theme and start selling.',
  'storefront.empty.action': 'Create your store',
  'storefront.status.LIVE': 'live',
  'storefront.status.PAUSED': 'paused',
  'storefront.status.DRAFT': 'draft',
  'storefront.view_store': 'View Store Preview',
  'storefront.pause_store': 'Pause store',
  'storefront.go_live': 'Go live',
  'storefront.errors.generic': 'Something went wrong. Try again.',
  'storefront.errors.still_loading': 'Your storefront is still loading.',
  'storefront.notice.added': '"{name}" was added to your drafts.',
  'storefront.notice.published': '"{name}" is now live.',
  'storefront.notice.branding_saved': 'Branding saved.',
  'storefront.notice.features_saved': 'Pages and features saved.',
  'storefront.notice.listing_saved': 'Listing saved.',
  'storefront.current_theme.title': 'Current theme',
  'storefront.current_theme.description': 'What shoppers see on your storefront right now.',
  'storefront.current_theme.last_saved': 'Last saved {date}',
  'storefront.customize': 'Customize',
  'storefront.duplicate': 'Duplicate',
  'storefront.read_only': 'You have read-only access to store settings.',
  'storefront.loading_library': 'Loading your theme library…',
  'storefront.drafts.title': 'Draft themes',
  'storefront.drafts.new_badge': 'New',
  'storefront.drafts.description': 'Try a look safely - drafts are only visible to you until published.',
  'storefront.drafts.added': 'Added {date}',
  'storefront.drafts.publish': 'Publish',
  'storefront.drafts.more_actions': 'More actions for {name}',
  'storefront.drafts.delete_confirm': 'Delete the draft "{name}"?',
  'storefront.branding.title': 'Branding',
  'storefront.branding.description': 'Your logo and tab icon, used by every theme.',
  'storefront.branding.logo': 'Logo',
  'storefront.branding.logo_hint': 'Shown in your storefront header. Size it under Customize → Theme.',
  'storefront.branding.favicon': 'Favicon',
  'storefront.branding.favicon_hint': 'The small icon in the browser tab. Square, 32 pixels or larger.',
  'storefront.branding.logo_alt': 'Store logo',
  'storefront.branding.no_logo': 'No logo uploaded.',
  'storefront.qr.title': 'Storefront QR code',
  'storefront.qr.description':
    'One square for the counter, the delivery bag or a poster. Customers scan it to open your shop — and their phone offers to keep it on their home screen.',
  'storefront.qr.view': 'View QR code',
  'storefront.ai.title': 'Design your store in seconds',
  'storefront.ai.description':
    'Describe your business and the AI picks the industry theme that suits it best, then makes it yours - your accent colour and a welcome banner written for you. It lands in your drafts for review; nothing goes live until you publish it.',
  'storefront.ai.label': 'What do you sell, and to whom?',
  'storefront.ai.placeholder': 'e.g. Handmade jewellery for working women, minimal and premium',
  'storefront.ai.generating': 'Generating…',
  'storefront.ai.generate': 'Generate theme',
  'storefront.ai.stop': 'Stop',
  'storefront.ai.stopped': 'Theme generation stopped. Nothing was saved.',
  'storefront.ai.palette_label': 'Colour palette',
  'storefront.ai.ready_title': '"{name}" is ready in your drafts',
  'storefront.ai.ready_body': 'Built on the {base} theme with your colour and welcome banner. Nothing is live until you publish it.',
  'storefront.ai.ready_show': 'Show in drafts',
  'storefront.ai.stages.matching': 'Matching an industry theme',
  'storefront.ai.stages.naming': 'Naming your theme',
  'storefront.ai.stages.palette': 'Choosing colours',
  'storefront.ai.stages.style': 'Picking fonts and buttons',
  'storefront.ai.stages.hero': 'Writing the welcome banner',
  'storefront.ai.stages.saving': 'Saving to your library',
  'storefront.themes.title': 'Themes',
  'storefront.themes.description':
    'Every theme opens as a complete sample shop you can walk through — departments, products, search, cart and checkout. None of it is your data. Adding one creates a draft you can customise, and nothing goes live until you publish it.',
  'storefront.themes.see_all': 'See all themes',
  'storefront.themes.empty': 'No themes for that industry yet.',
  'storefront.domain.title': 'Domain',
  'storefront.domain.custom_before': 'Shoppers reach you at',
  'storefront.domain.custom_after': '.',
  'storefront.domain.subdomain_before': 'You’re on',
  'storefront.domain.subdomain_after': '. Connect a web address of your own.',
  'storefront.domain.manage': 'Manage domain',
  'storefront.domain.set_up': 'Set up a domain',
  'storefront.address.title': 'Store address',
  'storefront.address.current': 'Your store lives at',
  'storefront.address.change': 'Change address',
  'storefront.address.remaining': 'Changes left: {count} of {max}',
  'storefront.address.next_allowed': 'You can change it again on {date}.',
  'storefront.address.blocked_disabled':
    'Changing your store address is turned off. Contact support if you need a new one.',
  'storefront.address.blocked_limit':
    'You have used all your address changes. Contact support if you need a new one.',
  'storefront.address.old_addresses': 'Old addresses (still redirect here):',
  'storefront.address.dialog_title': 'Change your store address',
  'storefront.address.new_label': 'New address',
  'storefront.address.checking': 'Checking…',
  'storefront.address.available': 'Available',
  'storefront.address.reason_INVALID':
    'Use 3 to 63 lowercase letters, numbers and single hyphens.',
  'storefront.address.reason_RESERVED': 'That address is reserved.',
  'storefront.address.reason_TAKEN': 'That address is taken.',
  'storefront.address.reason_CURRENT': 'That is already your address.',
  'storefront.address.what_happens': 'What happens when you change it',
  'storefront.address.effect_redirect':
    '{old} keeps working and sends shoppers to your new address, so printed QR codes and links you have shared still work. No other store can take it.',
  'storefront.address.effect_signout':
    'Signed-in shoppers are signed out once and their carts start empty.',
  'storefront.address.effect_app':
    'Shoppers who installed your store as an app need to open the new address and install it again.',
  'storefront.address.effect_email': 'Emails to shoppers will come from {address}.',
  'storefront.address.effect_limit':
    'After this you can change it again in {days} days ({remaining} changes left).',
  'storefront.address.confirm': 'Change address',
  'storefront.address.changed': 'Your store now lives at {host}.',
  'storefront.address.save_failed': 'Could not change your store address.',
  'storefront.listing.title': 'Listing',
  'storefront.listing.description': 'How your store is described to shoppers and search engines.',
  'storefront.listing.edit': 'Edit listing',
  'storefront.listing.store_name': 'Store name',
  'storefront.listing.description_label': 'Description',
  'storefront.listing.description_hint': 'Shown to shoppers and used as the fallback SEO description.',
  'storefront.listing.seo_title': 'SEO title',
  'storefront.listing.seo_description': 'SEO description',
  'storefront.listing.save_failed': 'Could not save the listing.',
  'storefront.features.title': 'Pages and features',
  'storefront.features.description':
    'Turn off the parts of your shop you do not use. A page you turn off leaves your navigation and stops opening for anyone who types its address. Your products, categories, pages and contact form are never affected.',
  'storefront.features.cart.label': 'Cart',
  'storefront.features.cart.hint': 'Shoppers can add things to a basket.',
  'storefront.features.checkout.label': 'Checkout',
  'storefront.features.checkout.hint': 'Shoppers can pay for what is in it.',
  'storefront.features.accounts.label': 'Customer accounts',
  'storefront.features.accounts.hint':
    'Shoppers can sign in, save addresses and see past orders. Anyone who already has an account will not be able to sign in while this is off.',
  'storefront.features.search.label': 'Search',
  'storefront.features.search.hint': 'The search page and the search link in your header.',
  'storefront.features.blog.label': 'Blog',
  'storefront.features.blog.hint': 'Your blog index and posts. Your pages are not affected.',
  'storefront.features.careers.label': 'Careers',
  'storefront.features.careers.hint': 'A Careers page listing the roles you are hiring for. Off until you turn it on.',
  'storefront.features.hover_image.label': 'Show next photo on hover',
  'storefront.features.hover_image.hint': 'Product cards switch to the next photo in the gallery when a shopper points at them.',
  'storefront.features.hover_image.follows_theme': 'Following your theme for now. Switch it to make it your own choice.',
  'storefront.features.checkout_needs_cart': 'Checkout needs a cart.',
  'storefront.features.enquiry_label': 'Button on a product page',
  'storefront.features.enquiry_label_placeholder': 'Book an appointment',
  'storefront.features.enquiry_label_hint': 'Leave this empty to use the wording from your theme.',
  'storefront.features.enquiry_target': 'Where it goes',
  'storefront.features.enquiry_target_hint': 'A page on your shop, or a full https:// address.',
  'storefront.features.footnote':
    'Buttons you added to your own pages that point at a switched-off address will need updating.',
  'storefront.features.on': 'On',
  'storefront.features.off': 'Off',

  'create.all_industries': 'All industries',
  'create.errors.name': 'Enter a store name.',
  'create.errors.subdomain_short': 'Use at least 3 characters.',
  'create.errors.subdomain_pattern': 'Lowercase letters, numbers and single hyphens only.',
  'create.errors.description_long': 'Keep it under 1000 characters.',
  'create.errors.theme': 'Pick a theme to start with.',
  'create.errors.create_failed': 'Could not create your store. Try again.',
  'create.checking': 'Checking your storefront…',
  'create.no_access.title': 'No storefront yet',
  'create.no_access.description': 'Your account cannot create the store. Ask an owner or manager to set it up.',
  'create.title': 'Set up your store',
  'create.intro':
    'This is the shop your customers visit. Name it, claim its address and pick the theme it opens in — all of it can be changed later.',
  'create.details.title': 'Store details',
  'create.details.description': 'Shoppers read the name; the address is how they reach you.',
  'create.details.name': 'Store name',
  'create.details.address': 'Storefront address',
  'create.details.address_hint': 'Your shop will live at {subdomain}.neoncarts.com',
  'create.details.description_label': 'Description (optional)',
  'create.details.description_placeholder': 'Handloom kurtas made in Jaipur, shipped across India.',
  'create.details.description_hint': "Doubles as your storefront's default SEO description.",
  'create.theme.title': 'Choose a theme',
  'create.theme.description':
    'Each card is a real shop this platform ships, photographed whole. Open any of them as a complete sample shop in a new tab — browse the departments, open a product, fill a cart — then pick the one you want to start from. Nothing in a preview is your data, and the look can be changed at any time.',
  'create.theme.empty': 'No themes for that industry yet.',
  'create.submitting': 'Creating your store…',
  'create.submit': 'Create store',
  'create.setup_with_ai': 'Set up my storefront with AI after creating it',

  'payments.errors.generic': 'Something went wrong. Try again.',
  'payments.notice.connected': 'Payments connected. Your storefront can now take online payments.',
  'payments.notice.verified': 'Your keys are working.',
  'payments.notice.resumed': 'Online payments resumed.',
  'payments.notice.paused': 'Online payments paused. Your other checkout options still work.',
  'payments.notice.disconnected':
    'Payments disconnected. Shoppers now see only the other checkout options you have enabled.',
  'payments.read_only':
    'You have read-only access to store settings, so you can see how payments are set up but not change them.',
  'payments.title': 'Payments',
  'payments.intro':
    'Connect your own Razorpay account. Money from every sale is settled directly to your bank — NeonCarts never holds your funds.',
  'payments.badge.live': 'Live',
  'payments.badge.test_mode': 'Test mode',
  'payments.badge.paused': 'Paused',
  'payments.connected.title': 'Connected',
  'payments.connected.last_checked': 'last checked {date}',
  'payments.connected.not_checked': 'not checked yet',
  'payments.connected.test_keys':
    'These are test keys, so no real money will move. Swap them for your live keys when you are ready to sell.',
  'payments.connected.no_webhook_title': 'No webhook secret set.',
  'payments.connected.no_webhook_body':
    'Orders will not be marked paid until you add the webhook — a payment can succeed and your order will still say pending.',
  'payments.connected.last_error': 'Razorpay last said: {error}',
  'payments.connected.checking': 'Checking…',
  'payments.connected.check_keys': 'Check keys',
  'payments.connected.pause': 'Pause payments',
  'payments.connected.resume': 'Resume payments',
  'payments.connected.disconnect': 'Disconnect',
  'payments.setup.title': 'Set up payments',
  'payments.setup.description':
    'Until you connect a gateway your storefront cannot take online payments — only the other checkout options you have enabled.',
  'payments.form.replace_title': 'Replace your keys',
  'payments.form.connect_title': 'Connect Razorpay',
  'payments.form.description': 'From your Razorpay dashboard, under Settings → API Keys.',
  'payments.form.open_dashboard': 'Open Razorpay dashboard',
  'payments.form.key_id': 'Key ID',
  'payments.form.key_id_hint': 'Starts with rzp_test_ or rzp_live_.',
  'payments.form.key_secret': 'Key secret',
  'payments.form.key_secret_hint': 'Encrypted before it is stored. Never shown again.',
  'payments.form.webhook_secret': 'Webhook secret',
  'payments.form.webhook_secret_keep_hint': 'Leave blank to keep the one you already saved.',
  'payments.form.webhook_secret_new_hint': 'Add this after creating the webhook.',
  'payments.form.connecting': 'Checking with Razorpay…',
  'payments.form.submit': 'Save and connect',
  'payments.guide_card.title': 'New to Razorpay?',
  'payments.guide_card.description':
    'Read how to open a Razorpay account, complete its verification and generate the API keys this page asks for.',
  'payments.guide_card.link': 'Razorpay setup guide',
  'payments.checkout_card.title': 'Checkout options',
  'payments.checkout_card.description':
    'Choose which payment options shoppers see and their order — online payment, cash on delivery or ordering over WhatsApp.',
  'payments.checkout_card.link': 'Checkout options →',
  'payments.webhook.title': 'Webhook',
  'payments.webhook.description':
    'In Razorpay, go to Settings → Webhooks and add this URL. Without it, a payment can succeed while your order still says pending.',
  'payments.webhook.subscribe_before': 'Subscribe to',
  'payments.webhook.subscribe_and': 'and',
  'payments.webhook.subscribe_after':
    '. Razorpay will show you a secret when you save the webhook — paste it into the field above.',
  'payments.webhook.unique':
    'This URL is unique to your store. Razorpay signs every webhook with your own secret, so nobody else’s events can be accepted as yours.',

  'checkout.title': 'Checkout options',
  'checkout.intro':
    'Choose which ways to pay your shoppers see at checkout, and the order they appear in. Only enabled and fully set-up options are shown.',
  'checkout.loading': 'Loading your checkout options…',
  'checkout.empty.title': 'No storefront yet',
  'checkout.empty.description': 'Create your store to choose how shoppers pay.',
  'checkout.empty.action': 'Create your store',
  'checkout.notice.saved': 'Checkout options saved.',
  'checkout.errors.generic': 'Something went wrong. Try again.',
  'checkout.errors.money': 'Enter an amount of 0 or more, with up to two decimals.',
  'checkout.errors.max_below_min': 'The maximum must be at least the minimum.',
  'checkout.errors.phone': 'Enter a WhatsApp number with its country code, like +91 98765 43210.',
  'checkout.description.RAZORPAY': 'Cards, UPI, netbanking and wallets through your own Razorpay account.',
  'checkout.description.COD': 'The shopper pays when the order arrives.',
  'checkout.description.WHATSAPP': 'The order opens as a prefilled WhatsApp chat with your business number.',
  'checkout.readiness.shown': 'Shown to shoppers',
  'checkout.readiness.setup': 'Needs setup',
  'checkout.readiness.checking': 'Checking…',
  'checkout.readiness.hidden': 'Hidden',
  'checkout.enable': 'Enable {method}',
  'checkout.badge.live': 'Live',
  'checkout.badge.test_mode': 'Test mode',
  'checkout.badge.paused': 'Paused',
  'checkout.instructions': 'Instructions',
  'checkout.instructions_hint': 'Shown under the option at checkout.',
  'checkout.razorpay.checking': 'Checking your gateway…',
  'checkout.razorpay.connected_as': 'Connected as {account}.',
  'checkout.razorpay.your_account': 'your Razorpay account',
  'checkout.razorpay.not_connected': 'Not connected. Shoppers will not see this option until it is.',
  'checkout.razorpay.paused': 'Online payments are paused, so this option is hidden until you resume them.',
  'checkout.razorpay.no_webhook_title': 'No webhook secret set.',
  'checkout.razorpay.no_webhook_body':
    'Orders will not be marked paid until you add the webhook on the Payments page.',
  'checkout.razorpay.manage_keys': 'Manage Razorpay keys',
  'checkout.razorpay.instructions_placeholder': 'e.g. UPI, cards and netbanking accepted',
  'checkout.cod.description': 'Charge a handling fee, or limit it to certain order sizes.',
  'checkout.cod.fee': 'Fee',
  'checkout.cod.fee_hint': 'Added to the order total when the shopper chooses cash on delivery.',
  'checkout.cod.min': 'Minimum order',
  'checkout.cod.min_placeholder': 'No minimum',
  'checkout.cod.min_hint': 'Optional. Hidden on smaller orders.',
  'checkout.cod.max': 'Maximum order',
  'checkout.cod.max_placeholder': 'No maximum',
  'checkout.cod.max_hint': 'Optional. Hidden on larger orders.',
  'checkout.cod.instructions_placeholder': 'e.g. Please keep exact change ready',
  'checkout.whatsapp.description':
    'Instead of paying on the site, the shopper sends you their order as a message.',
  'checkout.whatsapp.phone': 'WhatsApp number',
  'checkout.whatsapp.phone_hint':
    'Your WhatsApp Business number with country code. Orders open a chat with this number.',
  'checkout.whatsapp.greeting': 'Greeting',
  'checkout.whatsapp.greeting_placeholder': "Hi! I'd like to place this order:",
  'checkout.whatsapp.greeting_hint': 'The first line of the prefilled message.',
  'checkout.whatsapp.instructions_placeholder': 'e.g. We confirm your order and payment details on WhatsApp',
  'checkout.order.title': 'Order at checkout',
  'checkout.order.description':
    'The first option is what a shopper sees selected. Drag rows or use the arrows to reorder; switch an option off to hide it.',
  'checkout.preview.title': 'What shoppers see',
  'checkout.preview.in_order': 'In this order, at checkout.',
  'checkout.preview.checking': 'Checking your payment gateway…',
  'checkout.preview.nothing': 'Nothing yet.',
  'checkout.preview.none_shown':
    'No checkout option is currently shown to shoppers — they will not be able to place orders.',
  'checkout.fix_fields': 'Fix the highlighted fields to save.',
  'checkout.read_only': 'You have read-only access to store settings.',

  'qr.title': 'Storefront QR code',
  'qr.intro': 'One square that opens your shop on any phone — and offers to install it as an app.',
  'qr.loading': 'Loading your QR code…',
  'qr.no_access.title': "You don't have access to store settings",
  'qr.no_access.description': 'Ask an owner or admin for access to your storefront.',
  'qr.missing.title': 'No storefront yet',
  'qr.missing.description': 'A QR code points at your storefront, so there has to be one first.',
  'qr.missing.action': 'Create your store',
  'qr.load_failed.title': 'Could not load your QR code',
  'qr.load_failed.description': 'Something went wrong. Try again in a moment.',
  'qr.notice.downloaded': 'Saved to your downloads.',
  'qr.notice.share_copied': 'Sharing is not available in this browser, so the link was copied instead.',
  'qr.errors.download': 'The download failed. Try again in a moment.',
  'qr.errors.share': 'Could not open the share sheet.',
  'qr.copy_link': 'Copy link',
  'qr.image_alt': 'QR code linking to {name}',
  'qr.scanning_opens': 'Scanning this opens',
  'qr.never_changes':
    'This never changes. Redesign your shop, swap your theme, add a domain — the same printed square keeps working.',
  'qr.share': 'Share',
  'qr.print': 'Print',
  'qr.download.title': 'Download',
  'qr.download.description': 'Pick the size for where it is going. Bigger is better for anything printed.',
  'qr.download.designer_before': 'Working with a designer?',
  'qr.download.designer_link': 'Download the SVG',
  'qr.download.designer_after': '— it stays sharp at any size.',
  'qr.size.small': 'Small',
  'qr.size.small_hint': 'Social posts, WhatsApp',
  'qr.size.medium': 'Medium',
  'qr.size.medium_hint': 'Table cards, flyers',
  'qr.size.large': 'Large',
  'qr.size.large_hint': 'Posters, shop windows',
  'qr.customers.title': 'What your customers see',
  'qr.customers.description': 'The same code does both jobs — a quick visit, or a shop they keep.',
  'qr.customers.step_1': 'They point their camera at the code. No app, no typing.',
  'qr.customers.step_2': 'Your storefront opens, wearing your theme and your logo.',
  'qr.customers.step_3': 'Their phone offers to add your shop to their home screen.',
  'qr.customers.step_4': 'From then on it opens like an app — straight into your shop.',
  'push.title': 'Order notifications',
  'push.description': 'Shoppers who allow notifications on the order confirmation page get a notification on their phone or computer each time their order moves. Each one reads like the subject of the matching order email, in your wording.',
  'push.not_included': 'Your plan does not include push notifications. Upgrade to offer them to your shoppers.',
  'push.enabled': 'Send order notifications',
  'push.enabled_hint': 'Off, shoppers are not offered notifications and none are sent. Shoppers already signed up are kept for when you turn it back on.',
  'push.save_failed': 'Could not save. Try again in a moment.',
  'push.subscribers_one': '{count} device is following orders at your shop.',
  'push.subscribers_other': '{count} devices are following orders at your shop.',

  'api.checkout_method.RAZORPAY': 'Online payment (Razorpay)',
  'api.checkout_method.COD': 'Cash on delivery',
  'api.checkout_method.WHATSAPP': 'Order via WhatsApp',
  // <<< storefront-pages
  // >>> domains-email
  'domains.title': 'Domains',
  'domains.domain': 'Domain',
  'domains.upgrade': 'Upgrade',
  'domains.see_plans': 'See plans',
  'domains.per_year': '{price}/yr',
  'domains.status.PENDING': 'Pending',
  'domains.status.PAYMENT_PENDING': 'Awaiting payment',
  'domains.status.REGISTRATION_PENDING': 'Registering',
  'domains.status.REGISTERED': 'Registered',
  'domains.status.DNS_CONFIGURATION_REQUIRED': 'Needs DNS records',
  'domains.status.DNS_VERIFICATION_PENDING': 'Checking DNS',
  'domains.status.VERIFIED': 'Verified',
  'domains.status.SSL_PROVISIONING': 'Securing',
  'domains.status.ACTIVE': 'Active',
  'domains.status.FAILED': 'Failed',
  'domains.status.DISCONNECTED': 'Disconnected',
  'domains.status.EXPIRED': 'Expired',
  'domains.source.PURCHASED': 'Bought here',
  'domains.source.EXTERNAL': 'Connected',
  'domains.availability.AVAILABLE': 'Available',
  'domains.availability.REGISTERED': 'Already registered',
  'domains.availability.PREMIUM': 'Premium — not sold here',
  'domains.availability.UNSUPPORTED': 'Not supported',
  'domains.availability.INVALID': 'Invalid name',
  'domains.availability.UNKNOWN': 'Could not check',
  'domains.page.back': 'Storefront',
  'domains.page.read_only':
    'You have read-only access to store settings, so you can see your domains but not change them.',
  'domains.page.intro':
    'Give your shop its own web address — buy a new one here, or connect one you already own. Your shop keeps working on its NeonCarts address throughout, so nothing goes offline while you set this up.',
  'domains.page.email_connected.before':
    'Your email provider is connected. Open a verified domain below and choose',
  'domains.page.email_connected.after': 'to finish setting it up.',
  'domains.page.plan_excludes_custom':
    'Your plan does not include custom domains. You can look for a name, but buying or connecting one needs a bigger plan.',
  'domains.page.your_domains': 'Your domains',
  'domains.page.your_domains_description':
    'Every address that reaches this shop. The primary one is what shoppers see in their browser and in the links you share.',
  'domains.page.load_domains_failed': 'Could not load your domains. Refresh to try again.',
  'domains.page.find_title': 'Find a new domain',
  'domains.page.find_description':
    'Search for a name, pick the ending you like, and pay — we register it, point it at your shop and keep it renewed.',
  'domains.page.loading_prices': 'Loading prices…',
  'domains.page.load_prices_failed': 'Could not load domain prices. Refresh to try again.',
  'domains.page.purchase_disabled':
    'Buying domains is not available right now. You can still connect one you own.',
  'domains.page.registration_not_included':
    'Buying a domain through NeonCarts is not included in your plan. You can still connect one you own.',
  'domains.page.connect_title': 'Connect a domain you already own',
  'domains.page.connect_description':
    'Point a domain from any registrar at this shop. You’ll add two DNS records to prove it is yours — nothing changes for shoppers until that is done.',
  'domains.panel.title': 'Your own domain',
  'domains.panel.description':
    'Point a domain you own at this shop. You’ll add two DNS records to prove it is yours — nothing changes for shoppers until that is done.',
  'domains.panel.adding': 'Adding…',
  'domains.panel.add': 'Add domain',
  'domains.panel.add_failed': 'Could not add that domain.',
  'domains.panel.ownership_confirmed': 'Ownership confirmed.',
  'domains.panel.not_verified': 'Not verified yet.',
  'domains.panel.live': 'Live',
  'domains.panel.verified_finishing': 'Verified — finishing setup',
  'domains.panel.waiting_for_records': 'Waiting for your DNS records',
  'domains.panel.propagation':
    'DNS changes can take up to an hour to spread. Your shop stays reachable on its neoncarts.com address the whole time.',
  'domains.card.primary': 'Primary',
  'domains.card.pay_now': 'Pay now',
  'domains.card.checking': 'Checking…',
  'domains.card.check_now': 'Check now',
  'domains.card.switching': 'Switching…',
  'domains.card.make_primary': 'Make primary',
  'domains.card.renew': 'Renew',
  'domains.card.reconnecting': 'Reconnecting…',
  'domains.card.reconnect': 'Reconnect',
  'domains.card.disconnect': 'Disconnect',
  'domains.card.disconnecting': 'Disconnecting…',
  'domains.card.confirm_disconnect': 'Yes, disconnect',
  'domains.card.keep_it': 'Keep it',
  'domains.card.disconnect_prompt.before': 'Disconnect',
  'domains.card.disconnect_prompt.after': '? Visitors will no longer reach your shop at this address.',
  'domains.card.disconnect_prompt.after_purchased':
    '? Visitors will no longer reach your shop at this address; the registration itself is kept.',
  'domains.card.made_primary': "{domain} is now your shop's main address.",
  'domains.card.renewal_started': 'Renewal started for {domain}.',
  'domains.steps.registered': 'Registered',
  'domains.steps.registered_since': 'Since {date}',
  'domains.steps.ownership': 'We can prove you own this domain',
  'domains.steps.routing': 'Visitors reach your shop',
  'domains.steps.certificate': 'Secure certificate in place',
  'domains.steps.www': 'www also works',
  'domains.facts.expires': 'Expires',
  'domains.facts.last_renewed': 'Last renewed',
  'domains.facts.last_renewal': 'Last renewal',
  'domains.facts.paid': 'Paid',
  'domains.facts.charge_one': '{amount} for {count} year',
  'domains.facts.charge_other': '{amount} for {count} years',
  'domains.auto_renew.label': 'Auto-renew',
  'domains.auto_renew.hint_dated': "We'll ask you to pay before {date} so the domain never lapses.",
  'domains.auto_renew.hint': 'We will ask you to pay before it expires so the domain never lapses.',
  'domains.connect.label': 'Domain you own',
  'domains.connect.connecting': 'Connecting…',
  'domains.connect.connect': 'Connect',
  'domains.connect.include_www': 'Also connect the www version',
  'domains.connect.include_www_hint':
    'For a bare domain like example.com, so www.example.com reaches the shop too.',
  'domains.connect.failed': 'Could not connect that domain.',
  'domains.connect.added': '{domain} added. Add the DNS records below at your domain provider.',
  'domains.connect.next_step': 'Next step',
  'domains.connect.dismiss': 'Dismiss',
  'domains.connect.track_progress': "Once they are in, we check them automatically - you can follow the progress on the domain's card.",
  'domains.connect.view_card': 'Go to the domain card',
  'domains.connect.connected_as':
    '{typed} cannot point at your shop directly, so we connected {connected}. At your DNS provider, redirect {typed} to https://{connected}.',
  'domains.dns.heading': 'Add these at your domain registrar',
  'domains.dns.role.ownership': 'Prove you own it',
  'domains.dns.role.routing': 'Send visitors to your shop',
  'domains.dns.role.www': 'Make www work too',
  'domains.dns.propagation':
    'DNS changes can take up to an hour to spread. Your shop stays reachable on its NeonCarts address the whole time.',
  'domains.list.loading_label': 'Loading your domains',
  'domains.list.loading': 'Loading your domains…',
  'domains.list.empty_title': 'No domains yet',
  'domains.list.empty_description':
    'Buy a new web address below, or connect one you already own. Your shop keeps working on its NeonCarts address either way.',
  'domains.troubleshooting': 'Troubleshooting',
  'domains.search.renews_at': ', renews at {price}/yr',
  'domains.search.buy': 'Buy',
  'domains.search.label': 'Search for a name',
  'domains.search.searching': 'Searching…',
  'domains.search.hint': 'Just the name — pick the endings below.',
  'domains.search.endings': 'Endings to search',
  'domains.search.failed': 'Could not search right now.',
  'domains.search.no_results': 'Nothing came back for “{query}”. Try another word.',
  'domains.purchase.years_one': '{count} year',
  'domains.purchase.years_other': '{count} years',
  'domains.purchase.renew_title': 'Renew {domain}',
  'domains.purchase.buy_title': 'Buy {domain}',
  'domains.purchase.opening_payment': 'Opening payment…',
  'domains.purchase.continue_to_payment': 'Continue to payment',
  'domains.purchase.pay': 'Pay {amount}',
  'domains.purchase.extend_by': 'Extend by',
  'domains.purchase.register_for': 'Register for',
  'domains.purchase.price_per_year': 'Price per year',
  'domains.purchase.total': 'Total ({currency})',
  'domains.purchase.confirmed_at_checkout': 'Confirmed at checkout',
  'domains.purchase.renews_at': 'Renews at',
  'domains.purchase.auto_renew': 'Renew automatically',
  'domains.purchase.auto_renew_hint':
    'We’ll ask you to pay again before it expires, so your shop never goes offline. You can switch this off later.',
  'domains.purchase.renew_failed': 'Could not start the renewal.',
  'domains.purchase.purchase_failed': 'Could not start the purchase.',
  'domains.checkout.processing':
    'Payment received and being processed. Registering your domain — this usually takes a minute.',
  'domains.checkout.received': 'Payment received. Registering your domain — this usually takes a minute.',
  'domains.checkout.purchased_success': 'You have purchased {domain} successfully.',
  'domains.checkout.renewed_success': 'You have renewed {domain} successfully.',
  'domains.checkout.registering':
    'It is listed under Your domains below — registering it usually takes a minute.',
  'domains.checkout.cancelled': 'Payment cancelled. Nothing was charged.',
  'domains.checkout.open_failed': 'We could not open the payment window. Try again in a moment.',

  'email.business_email': 'Business Email',
  // --- Business Email shell: header, state banner, DNS health, activity ------
  // pages/DomainEmailPage + components/email/*. Enum-valued keys use the API's codes verbatim.
  'email.health.NOT_CONFIGURED': 'Not configured',
  'email.health.IN_PROGRESS': 'Setting up',
  'email.health.HEALTHY': 'Active',
  'email.health.NEEDS_ATTENTION': 'Needs attention',
  'email.page.last_checked': 'Last checked {time}',
  'email.page.never_checked': 'Not checked yet',
  'email.page.loading': 'Loading your Business Email setup…',
  'email.page.retry': 'Try again',
  'email.page.dismiss': 'Dismiss',
  'email.card.set_up': 'Set up Business Email',
  'email.card.status': '{provider} · {status}',
  'email.banner.NOT_CONFIGURED.title': 'Business Email isn’t set up yet',
  'email.banner.NOT_CONFIGURED.body':
    'Send and receive email as you@{domain} through a provider you choose. We connect the domain and guide you through every step.',
  'email.banner.IN_PROGRESS.title': 'Setting up Business Email',
  'email.banner.HEALTHY.title': 'Business Email is active',
  'email.banner.NEEDS_ATTENTION.title': 'Business Email needs attention',
  'email.banner.configure': 'Configure Business Email',
  'email.banner.fact.provider': 'Provider',
  'email.banner.fact.organisation': 'Organisation',
  'email.banner.fact.configured': 'Active since',
  'email.actions.reconnect': 'Reconnect {provider}',
  'email.actions.reauthorize': 'Re-authorize {provider}',
  'email.actions.verify_dns': 'Verify DNS',
  'email.actions.retry': 'Retry',
  'email.actions.change_provider': 'Change provider',
  'email.providers.choose_title': 'Choose your Business Email provider',
  'email.providers.requirements': 'What you need',
  'email.providers.use': 'Set up with {provider}',
  'email.providers.current': 'Current provider',
  'email.providers.other_title': 'Using another provider?',
  'email.providers.other_action': 'Set up manually',
  'email.dns_health.title': 'DNS health',
  'email.dns_health.managed': 'We manage this domain’s DNS, so we write these records for you.',
  'email.dns_health.unmanaged': 'Your DNS is hosted elsewhere, so add these records at your DNS provider.',
  'email.dns_health.check': 'Check DNS',
  'email.dns_health.show_advanced': 'Show advanced DNS details',
  'email.dns_health.hide_advanced': 'Hide advanced DNS details',
  'email.dns_health.optional': 'Optional',
  'email.dns_health.label.OWNERSHIP': 'Verification',
  'email.dns_health.label.MAIL_ROUTING': 'MX',
  'email.dns_health.label.SPF': 'SPF',
  'email.dns_health.label.DKIM': 'DKIM',
  'email.dns_health.label.DMARC': 'DMARC',
  'email.dns_health.state.VERIFIED': 'Verified',
  'email.dns_health.state.PENDING': 'Pending',
  'email.dns_health.state.MISSING': 'Missing',
  'email.dns_health.state.INVALID': 'Invalid',
  'email.dns_health.state.ATTENTION': 'Needs attention',
  'email.dns_health.state.NOT_REQUIRED': 'Not required',
  'email.dns_health.what.OWNERSHIP': 'Proves to your email provider that this domain is yours.',
  'email.dns_health.what.MAIL_ROUTING': 'Tells the internet where to deliver email sent to your domain.',
  'email.dns_health.what.SPF': 'Lists who may send email as your domain, so your mail is not marked as spam.',
  'email.dns_health.what.DKIM': 'Adds a digital signature to your outgoing mail so receivers can trust it.',
  'email.dns_health.what.DMARC':
    'Tells receiving servers what to do with mail that pretends to be from you. Recommended, and yours to publish.',
  'email.dns_health.fix.VERIFIED': 'Nothing to do — this is in place.',
  'email.dns_health.fix.PENDING':
    'We are waiting for this to show up. DNS changes can take up to an hour — check again later.',
  'email.dns_health.fix.MISSING':
    'We could not find this record. Open the advanced DNS details, copy the values and add them at your DNS provider.',
  'email.dns_health.fix.INVALID':
    'A record exists but has a different value. Update it to match the value in the advanced DNS details.',
  'email.dns_health.fix.ATTENTION':
    'This needs a value only your email provider can give you. Paste it in the advanced DNS details so we can check it.',
  'email.dns_health.fix.NOT_REQUIRED': 'Your email provider does not need this record.',
  'email.activity.title': 'Recent activity',
  'email.activity.status.STARTED': 'Started',
  'email.activity.status.SUCCEEDED': 'Succeeded',
  'email.activity.status.FAILED': 'Failed',
  'email.activity.status.UNCHANGED': 'No change',
  'email.callback.mailbox_connected': 'Your business email address is connected.',
  'email.callback.PROVIDER_AUTH_FAILED': 'The sign-in with your email provider did not work. Please try again.',
  'email.callback.PROVIDER_CONSENT_REQUIRED':
    'Your email provider needs an administrator to approve this. Sign in again with an account that manages your organisation.',
  'email.callback.PROVIDER_CONNECTION_REVOKED':
    'The connection to your email provider was withdrawn. Reconnect to keep your email working.',
  'email.callback.PROVIDER_APP_MISCONFIGURED':
    'This email provider is not set up correctly on NeonCarts yet. Please contact support.',
  'email.callback.PROVIDER_ORGANIZATION_NOT_FOUND':
    'We could not find a business account for that sign-in. Use your work account rather than a personal one.',
  'email.callback.PROVIDER_API_ERROR':
    'Your email provider did not respond properly. Please try again in a few minutes.',
  'email.callback.PROVIDER_TIMEOUT': 'Your email provider took too long to answer. Please try again.',
  'email.callback.PROVIDER_RATE_LIMITED': 'Your email provider asked us to slow down. Wait a minute and try again.',
  'email.callback.EMAIL_SUBSCRIPTION_REQUIRED':
    'That account does not have an email subscription. Add a mailbox plan with your provider, then try again.',
  'email.callback.DOMAIN_ALREADY_CONNECTED': 'This domain is already connected to Business Email.',
  'email.callback.GOOGLE_WORKSPACE_NOT_CONFIGURED': 'Google Workspace business email is not available here yet.',
  'email.callback.ZOHO_MAIL_NOT_CONFIGURED': 'Zoho Mail business email is not available here yet.',
  'email.callback.MAILBOX_DOMAIN_MISMATCH':
    'That address is not on this domain. Sign in with a mailbox that ends in this domain.',
  'email.callback.MAILBOX_ADDRESS_MISMATCH':
    'You signed in as a different address. Sign in with the same mailbox you are reconnecting.',
  'email.callback.MAILBOX_SEND_PERMISSION_MISSING':
    'Permission to send email was not granted. Try again and approve sending when asked.',
  'email.callback.MAILBOX_REAUTHORIZE_REQUIRED': 'This mailbox needs you to sign in again.',
  'email.callback.OAUTH_STATE_INVALID':
    'That sign-in link was not valid or has expired. Start the connection again.',
  'email.callback.connected': 'Your email provider is connected. We are finishing the setup for this domain.',
  'email.callback.MICROSOFT_ADMIN_CONSENT_REQUIRED':
    'Microsoft needs an administrator to approve this. Sign in again with an account that can manage your organisation’s domains.',
  'email.callback.consent_required':
    'The connection was not approved at Microsoft. Try again with an account that can manage your organisation’s domains.',
  'email.callback.MICROSOFT_TENANT_NOT_FOUND':
    'We could not find a Microsoft 365 organisation for that account. Sign in with your work account rather than a personal one.',
  'email.callback.MICROSOFT365_NOT_CONFIGURED': 'Microsoft 365 business email is not available here yet.',
  'email.callback.expired': 'That sign-in link expired. Start the connection again.',
  'email.callback.invalid': 'That sign-in link was not valid. Start the connection again.',
  'email.callback.failed': 'The sign-in did not complete. Please try again.',
  'email.page.intro':
    'Use your own domain for email — {address} instead of a personal inbox. NeonCarts connects your domain and sets up the DNS; your email provider hosts the mailboxes.',
  'email.page.load_domain_failed': 'Could not load this domain.',
  'email.page.verify_first.before': 'Verify that you own',
  'email.page.verify_first.after': 'before setting up email on it.',
  'email.page.finish_connecting': 'Finish connecting the domain',
  'email.page.hosting_title': 'Email hosting',
  'email.page.hosting_description':
    'Email hosting is provided by Microsoft 365 or another provider you choose. An eligible subscription with them is required — NeonCarts does not sell mailboxes.',
  'email.page.load_setup_failed': 'Could not load your Business Email setup.',
  'email.disconnect.title': 'Disconnect {provider}?',
  'email.disconnect.keep': 'Keep it connected',
  'email.disconnect.disconnecting': 'Disconnecting…',
  'email.disconnect.disconnect': 'Disconnect',
  'email.disconnect.warning.before': 'Disconnecting {provider} may affect email delivery for',
  'email.disconnect.warning.after': '.',
  'email.disconnect.mailboxes_kept': 'Your mailboxes at {provider} are not deleted, and nothing is cancelled.',
  'email.disconnect.stops_managing': 'NeonCarts stops managing this domain’s email DNS.',
  'email.disconnect.reconnect_any_time': 'You can connect it again at any time.',
  'email.disconnect.remove_records': 'Also remove the DNS records we added.',
  'email.disconnect.remove_records_hint':
    'Only records NeonCarts created are removed. Anything you added yourself is left exactly where it is.',
  'email.panel.generic_error': 'Something went wrong.',
  'email.panel.value_saved': 'Saved. We are checking that record now.',
  'email.panel.microsoft_connected': 'Microsoft 365 is connected',
  'email.panel.signed_in.before': 'Signed in to',
  'email.panel.signed_in.after': '. Set up business email on {domain} with the same account.',
  'email.panel.your_organisation': 'your organisation',
  'email.panel.setting_up': 'Setting up…',
  'email.panel.set_up_for': 'Set up email for {domain}',
  'email.panel.what_you_get': 'What you get',
  'email.panel.your_provider': 'your email provider',
  'email.panel.checking': 'Checking…',
  'email.panel.verify_domain': 'Verify domain',
  'email.panel.check_configuration': 'Check configuration',
  'email.panel.manage_in': 'Manage in {provider}',
  'email.panel.manual_steps': 'Things only you can do',
  'email.panel.open': 'Open',
  'email.panel.next_steps': 'What to do next',
  'email.steps.connected': '{provider} connected',
  'email.steps.verified': '{domain} verified with {provider}',
  'email.steps.dns': 'DNS records in place',
  'email.steps.dns_managed': 'We manage this domain’s DNS, so we add these for you.',
  'email.steps.dns_unmanaged': 'Your DNS is managed elsewhere, so you add these yourself.',
  'email.steps.ready': 'Email ready',
  'email.mx.detected': 'Existing email service detected.',
  'email.mx.receives': 'This domain already receives email. We have not changed where mail is delivered.',
  'email.mx.receives_through':
    'This domain already receives email through {provider}. We have not changed where mail is delivered.',
  'email.mx.review': 'Review the change',
  'email.mx.dialog_title': 'Existing email service detected',
  'email.mx.confirming': 'Confirming…',
  'email.mx.continue': 'Continue',
  'email.mx.route.before': 'Changing these records will route incoming email for',
  'email.mx.route.after': 'to {provider}. Mail sent to this domain will stop arriving wherever it goes today.',
  'email.mx.likely.before': 'This domain’s email currently looks like it is hosted by',
  'email.mx.likely.after': '.',
  'email.mx.nothing': 'Nothing',
  'email.mx.receiving_now': 'Receiving email now',
  'email.mx.new_records': 'New {provider} records',
  'email.mx.already_delivered':
    'Email already delivered to your old provider stays there — this only affects new mail.',
  'email.mx.mailboxes_first':
    'Set your mailboxes up at {provider} first if you can, so nothing arrives at an inbox that does not exist yet.',
  'email.mx.overlap': 'DNS changes can take up to an hour to spread, so expect a short overlap.',
  'email.dns.purpose.OWNERSHIP': 'Prove the domain is yours',
  'email.dns.purpose.MAIL_ROUTING': 'Deliver your email',
  'email.dns.purpose.SPF': 'Let your provider send as you',
  'email.dns.purpose.DKIM': 'Sign your outgoing mail',
  'email.dns.purpose.DMARC': 'Tell servers what to do with fakes',
  'email.dns.purpose.AUTODISCOVER': 'Set up Outlook and phone apps automatically',
  'email.dns.purpose.COLLABORATION': 'Chat and calls with other organisations',
  'email.dns.purpose.OTHER': 'Other records your provider needs',
  'email.dns.status.OK': 'In place',
  'email.dns.status.PENDING': 'Spreading',
  'email.dns.status.MISSING': 'Not found',
  'email.dns.status.MISMATCHED': 'Different value',
  'email.dns.status.UNKNOWN': 'Could not check',
  'email.dns.copy_field': 'Copy {field}',
  'email.dns.paste_value': 'Paste the value from your provider',
  'email.dns.save_and_check': 'Save and check',
  'email.dns.added_for_you': 'Added for you',
  'email.dns.field.host': 'Host',
  'email.dns.field.value': 'Value',
  'email.dns.field.priority': 'Priority',
  'email.dns.field.port': 'Port',
  'email.dns.field.weight': 'Weight',
  'email.dns.currently_published': 'Currently published:',
  'email.dns.heading_managed': 'DNS records — we manage these for you',
  'email.dns.heading_unmanaged': 'Add these at your DNS provider',
  'email.dns.propagation':
    'DNS changes can take up to an hour to spread. Your shop and any email you already have keep working the whole time.',
  'email.providers.opening': 'Opening…',
  'email.providers.connect': 'Connect {provider}',
  'email.providers.coming_soon': 'Coming soon',
  'email.providers.setup_guide': 'How to set up {provider}',
  'email.providers.subscription.before':
    'You will need your own {provider} subscription with a mailbox plan. NeonCarts connects',
  'email.providers.subscription.after': 'to it and sets up the DNS — {provider} hosts the email itself.',
  'email.providers.redirect': 'You will be redirected to {provider} to sign in. We never see your password.',
  'email.providers.already_connected': 'Already connected',
  'email.providers.title': 'Choose an email provider',
  'email.providers.intro.before': 'Business email lets you use addresses like',
  'email.providers.intro.after': 'instead of a personal inbox.',
  'email.providers.microsoft_unavailable':
    'Microsoft 365 is not switched on for this platform yet. You can still set up any other email provider by entering the DNS records they gave you.',
  'email.providers.footer':
    'Mailboxes, aliases and licences are always managed at your email provider. NeonCarts manages the domain and its DNS.',
  // --- Connected business emails (mailboxes a store sends from) -------------
  // components/email/accounts/*. Enum-valued keys use the API's codes verbatim.
  'email.accounts.title': 'Connected business emails',
  'email.accounts.description':
    'Addresses on {domain} your store can send email from — order confirmations, replies to customers and more.',
  'email.accounts.your_provider': 'your email provider',
  'email.accounts.no_default':
    'No default sender is chosen yet. Set one so your store emails go out from your own address.',
  'email.accounts.unsupported':
    '{provider} does not let NeonCarts send from your mailboxes, so business emails cannot be connected for this domain. Your email itself keeps working at {provider}.',
  'email.accounts.empty.title': 'No business email connected yet',
  'email.accounts.empty.description':
    'Connect an address like {address} so your store’s emails are sent from your own domain instead of a generic one. Once it is connected, send a test email to check that it works.',
  'email.accounts.empty.not_ready':
    'You can connect one as soon as email for {domain} is fully set up.',
  'email.accounts.default_sender': 'Default sender',
  'email.accounts.never': 'Never',
  'email.accounts.not_set': 'Not set',
  'email.accounts.none': 'None',
  'email.accounts.working': 'Working…',
  'email.accounts.errors.generic': 'Something went wrong. Please try again.',
  'email.accounts.fields.purpose': 'Used for',
  'email.accounts.fields.display_name': 'Display name',
  'email.accounts.fields.display_name_optional': 'Display name (optional)',
  'email.accounts.fields.default_sender': 'Default sender',
  'email.accounts.fields.provider': 'Provider',
  'email.accounts.fields.domain': 'Domain',
  'email.accounts.fields.health': 'Health',
  'email.accounts.fields.connection': 'Connection',
  'email.accounts.fields.authorization': 'Permission',
  'email.accounts.fields.verification': 'Verification',
  'email.accounts.fields.connected_at': 'Connected',
  'email.accounts.fields.last_checked': 'Last checked',
  'email.accounts.fields.last_test': 'Last test',
  'email.accounts.fields.added': 'Added',
  'email.accounts.fields.last_error': 'Last error',
  'email.accounts.purpose.GENERAL': 'General',
  'email.accounts.purpose.SUPPORT': 'Customer support',
  'email.accounts.purpose.ORDERS': 'Orders',
  'email.accounts.purpose.SALES': 'Sales',
  'email.accounts.purpose.BILLING': 'Billing',
  'email.accounts.purpose.MARKETING': 'Marketing',
  'email.accounts.purpose.NOREPLY': 'No-reply',
  'email.accounts.purpose.OTHER': 'Other',
  'email.accounts.health.HEALTHY': 'Active',
  'email.accounts.health.IN_PROGRESS': 'Setting up',
  'email.accounts.health.NEEDS_ATTENTION': 'Needs attention',
  'email.accounts.health.NOT_CONFIGURED': 'Not set up',
  'email.accounts.connection.NOT_CONNECTED': 'Not connected',
  'email.accounts.connection.CONNECTED': 'Connected',
  'email.accounts.connection.EXPIRED': 'Expired',
  'email.accounts.connection.REVOKED': 'Access revoked',
  'email.accounts.connection.ERROR': 'Error',
  'email.accounts.authorization.NOT_AUTHORIZED': 'Not granted',
  'email.accounts.authorization.PENDING': 'Waiting for sign-in',
  'email.accounts.authorization.AUTHORIZED': 'Granted',
  'email.accounts.authorization.CONSENT_REQUIRED': 'Approval needed',
  'email.accounts.authorization.FAILED': 'Failed',
  'email.accounts.verification.NOT_STARTED': 'Not checked yet',
  'email.accounts.verification.PENDING': 'Checking',
  'email.accounts.verification.VERIFIED': 'Verified',
  'email.accounts.verification.FAILED': 'Failed',
  'email.accounts.test_status.NEVER_SENT': 'Not sent yet',
  'email.accounts.test_status.SENT': 'Sent',
  'email.accounts.test_status.FAILED': 'Failed',
  'email.accounts.actions.menu': 'More actions for {address}',
  'email.accounts.actions.SEND_TEST': 'Send test email',
  'email.accounts.actions.VIEW': 'View details',
  'email.accounts.actions.EDIT': 'Edit',
  'email.accounts.actions.SET_DEFAULT': 'Set as default sender',
  'email.accounts.actions.VERIFY': 'Check connection',
  'email.accounts.actions.RECONNECT': 'Reconnect',
  'email.accounts.actions.REAUTHORIZE': 'Re-authorize',
  'email.accounts.actions.DISCONNECT': 'Disconnect',
  'email.accounts.actions.REMOVE': 'Remove',
  'email.accounts.fix.REAUTHORIZE': 'Re-authorize',
  'email.accounts.fix.RECONNECT': 'Reconnect',
  'email.accounts.fix.VERIFY': 'Check again',
  'email.accounts.notices.SET_DEFAULT': '{address} is now your default sender.',
  'email.accounts.notices.VERIFY': '{address} is connected and ready to send.',
  'email.accounts.notices.verify_problem': 'We checked the mailbox and it needs your attention.',
  'email.accounts.notices.DISCONNECT': '{address} was disconnected.',
  'email.accounts.notices.REMOVE': '{address} was removed.',
  'email.accounts.notices.EDIT': 'Changes to {address} were saved.',
  'email.accounts.add.button': 'Add business email',
  'email.accounts.add.title': 'Add a business email',
  'email.accounts.add.intro':
    'Connect a mailbox on {domain} so your store can send email from it.',
  'email.accounts.add.purpose_hint': 'Helps you tell your addresses apart. You can change it later.',
  'email.accounts.add.display_name_hint': 'The name customers see next to the address, such as your shop’s name.',
  'email.accounts.add.display_name_placeholder': 'Your shop’s name',
  'email.accounts.add.login_hint': 'Mailbox to sign in with (optional)',
  'email.accounts.add.login_hint_hint': 'We fill this in on the {provider} sign-in page to save you typing.',
  'email.accounts.add.hint_invalid': 'Use an address on {domain}, such as {example}.',
  'email.accounts.add.make_default': 'Make this the default sender',
  'email.accounts.add.make_default_hint': 'Store emails are sent from the default sender.',
  'email.accounts.add.sign_in_explainer':
    'Next, you will sign in at {provider} with the mailbox you want to connect — for example {example}.',
  'email.accounts.add.permission_explainer':
    'NeonCarts only gets permission to send email from that mailbox. We never read your mail and never see your password.',
  'email.accounts.add.continue': 'Continue to {provider}',
  'email.accounts.add.opening': 'Opening {provider}…',
  'email.accounts.test.title': 'Send a test email',
  'email.accounts.test.from': 'From',
  'email.accounts.test.via': 'Sent through {provider}',
  'email.accounts.test.recipient': 'Send it to',
  'email.accounts.test.recipient_hint': 'Use an inbox you can check right now.',
  'email.accounts.test.recipient_invalid': 'Enter a valid email address.',
  'email.accounts.test.send': 'Send test email',
  'email.accounts.test.sending': 'Sending…',
  'email.accounts.test.sending_detail': 'Sending through {provider}. This can take a few seconds.',
  'email.accounts.test.sent': 'Test email sent to {recipient}.',
  'email.accounts.test.check_inbox': 'Check the inbox — and the spam folder, in case it landed there.',
  'email.accounts.test.not_sent': 'The test email was not sent.',
  'email.accounts.test.failed_generic': 'We could not send the test email. Please try again.',
  'email.accounts.test.send_another': 'Send another',
  'email.accounts.test.retry': 'Retry',
  'email.accounts.test.try_again': 'Try again',
  'email.accounts.test.change_recipient': 'Change recipient',
  'email.accounts.test.hint_reauthorize':
    'Sign in at {provider} again to renew NeonCarts’ permission to send from this mailbox.',
  'email.accounts.test.hint_wait': 'Too many emails were sent in a short time. Wait a minute, then try again.',
  'email.accounts.test.hint_recipient': 'Check the recipient address for typos, or try a different inbox.',
  'email.accounts.test.hint_retry': '{provider} had a temporary problem. Trying again usually works.',
  'email.accounts.details.title': 'Business email details',
  'email.accounts.details.test_to': 'To {recipient}',
  'email.accounts.details.activity': 'Activity',
  'email.accounts.details.activity_loading': 'Loading activity…',
  'email.accounts.details.activity_failed': 'Could not load the activity for this mailbox.',
  'email.accounts.details.activity_empty': 'Nothing has happened to this mailbox yet.',
  'email.accounts.outcome.SUCCEEDED': 'Succeeded',
  'email.accounts.outcome.FAILED': 'Failed',
  'email.accounts.outcome.STARTED': 'Started',
  'email.accounts.outcome.UNCHANGED': 'No change',
  'email.accounts.events.MAILBOX_CONNECTED': 'Mailbox connected',
  'email.accounts.events.MAILBOX_RECONNECTED': 'Mailbox reconnected',
  'email.accounts.events.MAILBOX_AUTH_FAILED': 'Sign-in failed',
  'email.accounts.events.MAILBOX_VERIFIED': 'Connection checked',
  'email.accounts.events.MAILBOX_VERIFICATION_FAILED': 'Connection check failed',
  'email.accounts.events.MAILBOX_UPDATED': 'Details updated',
  'email.accounts.events.MAILBOX_DEFAULT_CHANGED': 'Default sender changed',
  'email.accounts.events.MAILBOX_DISCONNECTED': 'Mailbox disconnected',
  'email.accounts.events.MAILBOX_REMOVED': 'Mailbox removed',
  'email.accounts.events.TEST_EMAIL_SENT': 'Test email sent',
  'email.accounts.events.TEST_EMAIL_FAILED': 'Test email failed',
  'email.accounts.edit.title': 'Edit business email',
  'email.accounts.disconnect.title': 'Disconnect {address}?',
  'email.accounts.disconnect.keep': 'Keep it connected',
  'email.accounts.disconnect.confirm': 'Disconnect',
  'email.accounts.disconnect.disconnecting': 'Disconnecting…',
  'email.accounts.disconnect.stops_sending':
    'Your store stops sending email from this address, and NeonCarts forgets its permission to send.',
  'email.accounts.disconnect.mailbox_untouched':
    'The mailbox itself is untouched — its email, contacts and settings stay exactly as they are at {provider}.',
  'email.accounts.disconnect.was_default': 'This is your default sender. Choose another one afterwards.',
  'email.accounts.disconnect.reconnect_later': 'You can reconnect it at any time.',
  'email.accounts.remove.title': 'Remove {address}?',
  'email.accounts.remove.confirm': 'Remove',
  'email.accounts.remove.removing': 'Removing…',
  'email.accounts.remove.warning': 'This removes the address from NeonCarts, and it can no longer be used to send store emails.',
  'email.accounts.remove.mailbox_untouched': 'The mailbox at {provider} is not deleted.',
  'email.accounts.remove.was_default': 'This is your default sender. Choose another one afterwards.',
  'email.accounts.remove.add_again': 'To send from it again, you will need to add and connect it again.',
  // --- Store email sender: components/email/StoreSenderCard ------------------
  'email.sender.title': 'Store email sender',
  'email.sender.description':
    'Order confirmations, cancellations, status updates and password resets reach your customers from this address, with your store’s name beside it. Replies come to your support email.',
  'email.sender.loading': 'Loading your sender address…',
  'email.sender.load_failed': 'We could not load your sender address.',
  'email.sender.backup_title': 'Backup sender',
  'email.sender.backup_description':
    'Your connected mailbox sends your store emails. If it ever stops working, for example because its permission lapses, we send from the address below instead so your customers still hear from your store.',
  'email.sender.effective_label': 'Customers see it from',
  'email.sender.reply_to_label': 'Replies go to {address}',
  'email.sender.overridden':
    'Your emails go from {address}. If that mailbox stops working, we’ll send from {backup} instead.',
  'email.sender.overridden_platform':
    'Your emails go from {address}. If that mailbox stops working, we’ll send them from our platform address instead, still with your store’s name and your support email for replies.',
  'email.sender.not_enabled':
    'Sending from this address is not switched on for your store yet. Until it is, store emails come from our platform address, still with your store’s name and your support email for replies.',
  'email.sender.local_part_label': 'Sender address',
  'email.sender.local_part_hint': 'Leave it as {subdomain} to match your store address.',
  'email.sender.use_subdomain': 'Use my store address',
  'email.sender.support_email_label': 'Support email (Reply-To)',
  'email.sender.support_email_hint': 'Leave blank to use your business email.',
  'email.sender.error_taken': 'Another store already sends from this address. Try a different one.',
  'email.sender.error_reserved': 'This address is reserved. Please choose a different one.',
  'email.sender.save_failed': 'Could not save your sender settings.',
  'email.sender.saved': 'Sender settings saved.',
  'email.sender.saving': 'Saving…',
  'email.sender.save': 'Save sender',
  // <<< domains-email
};

export default store;
